import { render, staticRenderFns } from "./OptometristWxuser.vue?vue&type=template&id=24f33e25&scoped=true&"
import script from "./OptometristWxuser.vue?vue&type=script&lang=js&"
export * from "./OptometristWxuser.vue?vue&type=script&lang=js&"
import style0 from "./OptometristWxuser.vue?vue&type=style&index=0&id=24f33e25&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f33e25",
  null
  
)

export default component.exports